import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
// Utils & misc
import { cn } from '@repo/zolintra-utils';
// Style
import styles from './Skeleton.module.css';

const skeletonVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

export function Skeleton({
  shape, width, height, className, style,
}) {
  return (
    <motion.div
      className={cn([styles.skeleton, styles[shape], className])}
      style={{
        width, height, ...style,
      }}
      initial="hidden"
      animate="visible"
      exit="hidden"
      variants={skeletonVariants}
      transition={{ duration: 0.5 }}
    />
  );
}

Skeleton.propTypes = {
  shape: PropTypes.oneOf(['round', 'rectangle']).isRequired,
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
};

Skeleton.defaultProps = {
  className: null,
  style: {},
};

export default Skeleton;
